import { Link } from "react-router-dom";
import { Phone, Mail, Send } from "lucide-react";
import { site } from "@/config/site";

export const MobileContactBar = () => {
    return (
        <div
            data-testid="mobile-contact-bar"
            className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-[#06111F]/95 backdrop-blur-md border-t border-white/10 px-3 py-2.5 flex items-center justify-around"
        >
            <a
                href={`tel:${site.phoneLink}`}
                data-testid="mcb-call"
                className="flex flex-col items-center gap-0.5 text-white text-[11px] font-medium px-3 py-1"
            >
                <Phone className="w-5 h-5 text-[#14B8A6]" />
                <span>Zadzwoń</span>
            </a>
            <a
                href={`mailto:${site.email}`}
                data-testid="mcb-write"
                className="flex flex-col items-center gap-0.5 text-white text-[11px] font-medium px-3 py-1"
            >
                <Mail className="w-5 h-5 text-[#14B8A6]" />
                <span>Napisz</span>
            </a>
            <Link
                to="/kontakt"
                data-testid="mcb-quote"
                className="flex flex-col items-center gap-0.5 text-white text-[11px] font-semibold px-4 py-1 rounded-[10px] bg-[#14B8A6]/15 border border-[#14B8A6]/30"
            >
                <Send className="w-5 h-5 text-[#14B8A6]" />
                <span>Wycena</span>
            </Link>
        </div>
    );
};
